import React, { lazy } from 'react'

import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const PersonIndex = lazy(() => import('./person/Index'))

export const CrewWageCarRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--crew-wage-car']}>
    <Route path='*' element={<Index />} />
    <Route path='person/*' element={<PersonIndex />} />
  </SubRouter>
))
